"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _socket = _interopRequireDefault(require("socket.io-client"));

var _moment = _interopRequireDefault(require("moment"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _jwtDecode = _interopRequireDefault(require("jwt-decode"));

var _url = _interopRequireDefault(require("url"));

var _AccuracyLevels = _interopRequireDefault(require("./AccuracyLevels"));

var _ActionBatcher = _interopRequireDefault(require("./ActionBatcher"));

var _BoundedArray = _interopRequireDefault(require("../shared/BoundedArray"));

var _getCurrentState3 = _interopRequireDefault(require("../shared/getCurrentState"));

var _getServerStatus3 = _interopRequireDefault(require("../shared/getServerStatus"));

var _jsonReviver = _interopRequireDefault(require("./jsonReviver"));

var _log = _interopRequireWildcard(require("../shared/log"));

var _parser = _interopRequireWildcard(require("../shared/parser"));

var _subscribe3 = _interopRequireDefault(require("../shared/subscribe"));

var _Subscription = _interopRequireDefault(require("./Subscription"));

var _TimeSync = _interopRequireDefault(require("./TimeSync"));

var _initializeConnection = _interopRequireDefault(require("./initializeConnection"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

(0, _parser.setJsonReviver)(_jsonReviver["default"]);
/**
 * @private
 * This function is called each time a new state is received from the server.
 * It calls the proper listener if the state has really changed.
 * @param {Object} subscriptionCollection
 * @param {Object} newState
 */

function onStateUpdate(subscriptionCollection, newState) {
  var theSubscription = subscriptionCollection;
  theSubscription.lastUpdateTimestamp = +(0, _moment["default"])();
  var newStateJSON = JSON.stringify(newState);

  if (subscriptionCollection.lastStateJSON !== newStateJSON) {
    (0, _log["default"])("Received new state for domain '".concat(subscriptionCollection.domain, "'"));
    subscriptionCollection.subscriptions.forEach(function (subscription) {
      return subscription.listener(newState);
    });
    theSubscription.lastState = newState;
    theSubscription.lastStateJSON = newStateJSON;
  }
}
/**
 * @private
 * Send actions that were previously batched using an ActionBatcher.
 * @param {string} authToken
 * @param {Object} subscriptions
 * @param {Object} groupedActions
 * @param {Object} actions
 * @throws Will throw an error if the client's authenticated token is invalid and
   *         `onAuthTokenFailure` has not been set.
 */


function sendBatchedActions(_x, _x2, _x3) {
  return _sendBatchedActions.apply(this, arguments);
}
/**
 * Class for implementing an Anyware Intermedia Client
 * @alias module:Client
 */


function _sendBatchedActions() {
  _sendBatchedActions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(client, groupedActions, actions) {
    var onBatchedEmission;
    return regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            onBatchedEmission = client.onBatchedEmission;
            _context20.next = 3;
            return (0, _initializeConnection["default"])(client);

          case 3:
            if (!_context20.sent) {
              _context20.next = 8;
              break;
            }

            _context20.next = 6;
            return Promise.all(Object.keys(groupedActions).map( /*#__PURE__*/function () {
              var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(domain) {
                var groupedDomainActions, domainActions, formattedBatchedActions, emitBatchWithRetry;
                return regeneratorRuntime.wrap(function _callee19$(_context19) {
                  while (1) {
                    switch (_context19.prev = _context19.next) {
                      case 0:
                        groupedDomainActions = groupedActions[domain];
                        domainActions = actions.filter(function (action) {
                          return action.domain === domain;
                        });
                        /*
                          Format to send:
                          {
                            <ACTION>: [{ args: <ARGS>, count: <COUNT> }]
                          }
                        */

                        formattedBatchedActions = Object.keys(groupedDomainActions).reduce(function (formattedObj, action) {
                          var obj = _objectSpread({}, formattedObj);

                          obj[action] = Object.keys(groupedDomainActions[action]).map(function (argsKey) {
                            return groupedDomainActions[action][argsKey];
                          });
                          return obj;
                        }, {});
                        (0, _log["default"])("Emitting batched actions '".concat(JSON.stringify(formattedBatchedActions), "' on domain '").concat(domain, "'"));

                        emitBatchWithRetry = function emitBatchWithRetry(resolve) {
                          var isRetry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                          try {
                            client.actionSocket.emit('batchedActions', {
                              domain: domain,
                              batchedActions: formattedBatchedActions
                            }, function (_ref16) {
                              var status = _ref16.status,
                                  errCode = _ref16.errCode,
                                  errMessage = _ref16.errMessage,
                                  _ref16$warnings = _ref16.warnings,
                                  warnings = _ref16$warnings === void 0 ? [] : _ref16$warnings;

                              if (status === 'OK') {
                                onBatchedEmission(null, domainActions);
                                warnings.forEach(function (warning) {
                                  return _log["default"].warn("WARNING: ".concat(warning));
                                });
                                resolve();
                              } else if (errCode === 'INVALID_DOMAIN' && !isRetry) {
                                setTimeout(function () {
                                  emitBatchWithRetry(resolve, true);
                                }, 2000);
                              } else {
                                onBatchedEmission(errMessage, domainActions);
                                resolve();
                              }
                            });
                          } catch (err) {
                            onBatchedEmission(err.message, domainActions);
                          }
                        };

                        _context19.next = 7;
                        return new Promise(emitBatchWithRetry);

                      case 7:
                      case "end":
                        return _context19.stop();
                    }
                  }
                }, _callee19);
              }));

              return function (_x24) {
                return _ref15.apply(this, arguments);
              };
            }()));

          case 6:
            _context20.next = 9;
            break;

          case 8:
            onBatchedEmission('Failed to initialize connection');

          case 9:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));
  return _sendBatchedActions.apply(this, arguments);
}

var Client = /*#__PURE__*/function () {
  _createClass(Client, [{
    key: "getSockets",

    /**
     * (Async) Get the sockets used by the client to communicate with the servers.
     * @private (package)
     * @async
     * @throws Will throw an error if the client's authenticated token is invalid and
     *         `onAuthTokenFailure` has not been set.
     * @returns {Object} The sockets used by the client to communicate with
     *                   the servers , in the form of an object containing
     *                   an action attribute and a subscription attribute.
     */
    value: function () {
      var _getSockets = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _initializeConnection["default"])(this);

              case 2:
                if (!_context.sent) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", {
                  action: this.actionSocket,
                  subscription: this.subscriptionSocket
                });

              case 4:
                return _context.abrupt("return", null);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getSockets() {
        return _getSockets.apply(this, arguments);
      }

      return getSockets;
    }()
    /**
     * @private
     * @property {Object.<string, BoundedArray>} emissionTimestamps - Dictionary of bounded arrays
     *                                                                for keeping the timestamps
     *                                                                of X previous emissions for each
     *                                                                domain, to allow the client to
     *                                                                enforce a per-domain maximum
     *                                                                emission rate.
     */

  }], [{
    key: "shutUp",

    /**
     * Same as setting loggingEnabled to false, but funnier.
    */
    value: function shutUp() {
      Client.loggingEnabled = false;
    }
  }, {
    key: "loggingEnabled",

    /**
     * @static
     * @property {boolean} loggingEnabled - Indicates if the client should write logs to the output.
     */
    set: function set(enabled) {
      (0, _log.setLoggingEnabled)(enabled);
    }
  }]);

  /**
   * Instanciate a new Client.
   * @param {Object} params
   * @param {string} [params.url] - The fully qualified URL of the server.
   *                                Use this if you're connecting to a monolithic server.
   *                                Otherwise omit this parameter to connect to a scalable
   *                                architecture.
   * @param {string} [params.actionUrl] - The fully qualified URL of an aggregation server
   *                                      or the state server. Actions will be emitted on this URL.
   *                                      Use this if you're connecting to a scalable architecture.
   * @param {string} [params.subscriptionUrl] - The fully qualified URL of a synchronization server.
   *                                     The state will be fetched from this URL. Use this if
   *                                     you're connecting to a scalable architecture.
   */
  function Client(_ref) {
    var _this = this;

    var url = _ref.url,
        actionUrl = _ref.actionUrl,
        subscriptionUrl = _ref.subscriptionUrl;

    _classCallCheck(this, Client);

    _defineProperty(this, "emissionTimestamps", {});

    _defineProperty(this, "subscriptions", {});

    _defineProperty(this, "onRemoteError", function (errCode, errMessage) {
      throw new Error(errMessage);
    });

    _defineProperty(this, "onAuthTokenFailure", function (errMessage) {
      throw new Error(errMessage);
    });

    _defineProperty(this, "onBatchedEmission", function (error) {
      if (error) {
        throw new Error(error);
      }
    });

    _defineProperty(this, "onStateServerRestart", function () {});

    this.id = (0, _v["default"])();
    this.url = url;
    this.actionUrl = actionUrl;
    this.subscriptionUrl = subscriptionUrl;
    this.authToken = '';
    this.role = '';
    this.actionBatcher = new _ActionBatcher["default"]( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(groupedActions, actions) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return sendBatchedActions(_this, groupedActions, actions);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x4, _x5) {
        return _ref2.apply(this, arguments);
      };
    }());
  }
  /**
  * Close all connections between Client and Servers
  */


  _createClass(Client, [{
    key: "disconnect",
    value: function disconnect() {
      var _this2 = this;

      if (this.actionSocket) {
        this.actionSocket.disconnect();
      }

      if (this.subscriptionSocket) {
        this.subscriptionSocket.disconnect();
      }

      var domainSubscriptionArray = Object.keys(this.subscriptions);

      if (domainSubscriptionArray.length > 0) {
        domainSubscriptionArray.forEach(function (domain) {
          _this2.subscriptions[domain].subscriptions.forEach(function (subscription) {
            subscription.close();
          });
        });
      }

      if (this.sessionSubscription) {
        this.sessionSubscription.close();
      }

      delete this.actionSocket;
      delete this.subscriptionSocket;
      this.authToken = '';
      this.role = '';
    }
    /**
     * (Async) Get the current session ID set on the server(s). The
     * session ID is a random string that changes every time the state
     * or monolithic server is restarted.
     */

  }, {
    key: "getServerSessionID",
    value: function () {
      var _getServerSessionID = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$this$getCurren, id;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getCurrentState('meta/session');

              case 2:
                _yield$this$getCurren = _context3.sent;
                id = _yield$this$getCurren.id;
                return _context3.abrupt("return", id);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getServerSessionID() {
        return _getServerSessionID.apply(this, arguments);
      }

      return getServerSessionID;
    }()
    /**
     * (Async) Authenticate the client, in order to be granted a restricted role
     * (i.e. `SUPERUSER`, `THING`, or `DEMIGOD`).
     * @param {string} accountID - The account ID to use for authentication.
     * @param {string} password - The password corresponding to the provided account ID.
     * @throws Will throw an error if provided parameters are invalid.
     * @throws Will throw an error if authentication is not available on the server.
     * @returns {boolean} Either `true` if authentication succeeds, or `false` if it fails.
     */

  }, {
    key: "authenticate",
    value: function () {
      var _authenticate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(accountID, password) {
        var _this3 = this;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(typeof accountID !== 'string')) {
                  _context5.next = 2;
                  break;
                }

                throw new Error("Parameter \"accountID\" should be a string.Provided value is of type \"".concat(_typeof(accountID), "\""));

              case 2:
                if (!(typeof password !== 'string')) {
                  _context5.next = 4;
                  break;
                }

                throw new Error("Parameter \"password\" should be a string.Provided value is of type \"".concat(_typeof(password), "\""));

              case 4:
                return _context5.abrupt("return", new Promise( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(resolve) {
                    var authURL, authSocket;
                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            authURL = _url["default"].resolve(_this3.actionUrl || _this3.url, '/auth');
                            authSocket = (0, _socket["default"])(authURL, {
                              auth: {
                                accountID: accountID,
                                password: password
                              },
                              parser: _parser["default"],
                              transports: ['websocket', 'polling']
                            });
                            authSocket.on('authToken', function (_ref4) {
                              var authToken = _ref4.authToken,
                                  role = _ref4.role;

                              if (authToken) {
                                _this3.authToken = authToken;
                                _this3.role = role;
                              }

                              authSocket.disconnect();
                              resolve(!!authToken);
                            });
                            authSocket.on('authError', function (err) {
                              (0, _log["default"])(err);
                              _this3.role = '';
                              authSocket.disconnect();
                              resolve(false);
                            });

                          case 4:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));

                  return function (_x8) {
                    return _ref3.apply(this, arguments);
                  };
                }()));

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function authenticate(_x6, _x7) {
        return _authenticate.apply(this, arguments);
      }

      return authenticate;
    }()
    /**
     * Return the authentication token obtained by the client after authentication.
     * You can store this token in order to pass it to `setAuthToken` during subsequent
     * executions of your application, thus avoiding to have to authenticate again.
     * Will return `null` if the client is not authenticated.
     * @returns {string} The authentication token.
     */

  }, {
    key: "getAuthToken",
    value: function getAuthToken() {
      if (this.authToken === '') {
        return null;
      }

      return this.authToken;
    }
    /**
     * Get the JWT payload extracted from the client's authentication token
     * Will return `null` if the client is not authenticated.
     * @returns {object} The payload extracted from the client's authentication token.
     */

  }, {
    key: "getAuthTokenPayload",
    value: function getAuthTokenPayload() {
      if (this.authToken === '') {
        return null;
      }

      var payload = (0, _jwtDecode["default"])(this.authToken);
      return payload;
    }
    /**
     * Return the client's role.
     * @returns {string} either "USER", "SUPERUSER", "THING", "SERVER", or "DEMIGOD".
     */

  }, {
    key: "getRole",
    value: function getRole() {
      return this.role;
    }
    /**
     * (Async) Set the authentication token. If the client is not authenticated, this function
     * will authenticate the client using the provided authenticated token.
     * If the client is already authenticated, this will refresh the token on the server using
     * the provided authenticated token.
     * @param {string} authToken - The authentication token to use.
     * @throws Will throw an error if provided parameters are invalid.
     * @throws Will throw an error if the provided authenticated token is invalid and
     *         `onAuthTokenFailure` has not been set.
     * @returns {boolean} Wether the authentication or re-authentication succeeded or not.
     */

  }, {
    key: "setAuthToken",
    value: function () {
      var _setAuthToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(authToken) {
        var _this4 = this;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(typeof authToken !== 'string')) {
                  _context7.next = 2;
                  break;
                }

                throw new Error("Parameter \"authToken\" should be a string.Provided value is of type \"".concat(_typeof(authToken), "\""));

              case 2:
                if (!(this.authToken === '')) {
                  _context7.next = 5;
                  break;
                }

                this.authToken = authToken;
                return _context7.abrupt("return", (0, _initializeConnection["default"])(this));

              case 5:
                return _context7.abrupt("return", new Promise( /*#__PURE__*/function () {
                  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(resolve) {
                    return regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.next = 2;
                            return (0, _initializeConnection["default"])(_this4);

                          case 2:
                            if (!_context6.sent) {
                              _context6.next = 5;
                              break;
                            }

                            _this4.actionSocket.emit('refreshAuthToken', authToken, function (_ref6) {
                              var role = _ref6.role,
                                  status = _ref6.status;

                              if (status === 'OK') {
                                (0, _log["default"])('The authentication token provided to `setAuthToken` is valid.');
                                _this4.authToken = authToken;
                                _this4.role = role;
                                resolve(true);
                              } else {
                                (0, _log["default"])('The authentication token provided to `setAuthToken` is NOT valid.');
                                resolve(false);
                              }
                            });

                            if (!_this4.url) {
                              _this4.subscriptionSocket.emit('refreshAuthToken', authToken, function (_ref7) {
                                var role = _ref7.role,
                                    status = _ref7.status;

                                if (status === 'OK') {
                                  (0, _log["default"])('The authentication token provided to `setAuthToken` is valid.');
                                  _this4.authToken = authToken;
                                  _this4.role = role;
                                  resolve(true);
                                } else {
                                  (0, _log["default"])('The authentication token provided to `setAuthToken` is NOT valid.');
                                  resolve(false);
                                }
                              });
                            }

                          case 5:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  }));

                  return function (_x10) {
                    return _ref5.apply(this, arguments);
                  };
                }()));

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function setAuthToken(_x9) {
        return _setAuthToken.apply(this, arguments);
      }

      return setAuthToken;
    }()
    /**
     * Clear the client's authentication token to make it unauthenticated.
     */

  }, {
    key: "clearAuthToken",
    value: function clearAuthToken() {
      this.authToken = '';
      this.role = '';
      delete this.actionSocket.auth;
      delete this.subscriptionSocket.auth;
    }
    /**
     * (Async) Emit an action on a domain.
     * WARNING: There is a limit to the number of actions that can be emitted on a same domain
     *          per second. If your use case involves sending lots of actions in a short timespan,
     *          use `emitBatched` instead.
     * @param {string} domain - The name of the domain to perform an action on.
     * @param {string} action - The name of the action to emit.
     * @param {Object} [args = {}] - The action arguments to send with the action.
     * @throws Will throw an error if provided parameters are invalid.
     * @throws Will throw an error if the domain does not exist.
     * @throws Will throw an error if emitting too many actions on the same domain
     *         in a short timespan.
     * @throws Will throw an error if the action does not exist.
     * @throws Will throw an error if the client's authenticated token is invalid and
     *         `onAuthTokenFailure` has not been set.
     * @throws Will throw an error if the client's role is not allowed to execute this action.
     * @throws Will throw an error if the provided action arguments do  not pass the action's
     *         validation.
     * @throws Will throw an error if the server-side action handler mutates the domain's state
     *         directly (only when the server-side environment is set to "DEV").
     */

  }, {
    key: "emit",
    value: function () {
      var _emit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(domain, action) {
        var _this5 = this;

        var args,
            emissionTimestamps,
            emitWithRetry,
            _args8 = arguments;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                args = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : {};

                if (!(typeof domain !== 'string')) {
                  _context8.next = 3;
                  break;
                }

                throw new Error("Parameter \"domain\" should be a string.Provided value is of type \"".concat(_typeof(domain), "\""));

              case 3:
                if (!(typeof action !== 'string')) {
                  _context8.next = 5;
                  break;
                }

                throw new Error("Parameter \"action\" should be a string.Provided value is of type \"".concat(_typeof(action), "\""));

              case 5:
                if (!(_typeof(args) !== 'object')) {
                  _context8.next = 7;
                  break;
                }

                throw new Error("Parameter \"args\" should be an object.Provided value is of type \"".concat(_typeof(args), "\""));

              case 7:
                emissionTimestamps = this.emissionTimestamps[domain] || function () {
                  var boundedArray = new _BoundedArray["default"](4, [0, 0, 0, 0]);
                  _this5.emissionTimestamps[domain] = boundedArray;
                  return boundedArray;
                }();

                emissionTimestamps.push(+(0, _moment["default"])());

                if (!(emissionTimestamps.last - emissionTimestamps.first < 1000)) {
                  _context8.next = 11;
                  break;
                }

                throw new Error("Maximum emission rate exceeded for domain \"".concat(domain, "\". Please batch your actions using \"emitBatched\"."));

              case 11:
                _context8.next = 13;
                return (0, _initializeConnection["default"])(this);

              case 13:
                if (!_context8.sent) {
                  _context8.next = 17;
                  break;
                }

                (0, _log["default"])("Emitting action '".concat(action, "' on domain '").concat(domain, "'"));

                emitWithRetry = function emitWithRetry(resolve, reject) {
                  var isRetry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                  _this5.actionSocket.emit('action', {
                    domain: domain,
                    name: action,
                    args: args
                  }, function (_ref8) {
                    var status = _ref8.status,
                        errCode = _ref8.errCode,
                        errMessage = _ref8.errMessage,
                        _ref8$warnings = _ref8.warnings,
                        warnings = _ref8$warnings === void 0 ? [] : _ref8$warnings;

                    if (status === 'OK') {
                      warnings.forEach(function (warning) {
                        return _log["default"].warn("WARNING: ".concat(warning));
                      });
                      resolve();
                    } else if (errCode === 'INVALID_DOMAIN' && !isRetry) {
                      setTimeout(function () {
                        emitWithRetry(resolve, reject, true);
                      }, 2000);
                    } else {
                      reject(new Error(errMessage));
                    }
                  });
                };

                return _context8.abrupt("return", new Promise(emitWithRetry));

              case 17:
                return _context8.abrupt("return", null);

              case 18:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function emit(_x11, _x12) {
        return _emit.apply(this, arguments);
      }

      return emit;
    }()
    /**
     * Add an action to a batch of actions that will be sent within the next second.
     * Execution order is not guaranteed. The function provided to the `onBatchedEmission`
     * property will be called each time a batch of actions is sent.
     * @param {string} domain - The name of the domain to perform an action on.
     * @param {string} action - The name of the action to emit.
     * @param {Object} [args = {}] - The action arguments to send with the action.
     * @throws Will throw an error if provided parameters are invalid.
     * @throws Will throw the same errors as `emit`, but only after the next batched emission. You
     *         need to provide a function to the `onBatchedEmission` property in order
     *         to catch these errors.
     */

  }, {
    key: "emitBatched",
    value: function emitBatched(domain, action) {
      var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (typeof domain !== 'string') {
        throw new Error("Parameter \"domain\" should be a string.Provided value is of type \"".concat(_typeof(domain), "\""));
      }

      if (typeof action !== 'string') {
        throw new Error("Parameter \"action\" should be a string.Provided value is of type \"".concat(_typeof(action), "\""));
      }

      if (_typeof(args) !== 'object') {
        throw new Error("Parameter \"args\" should be an object.Provided value is of type \"".concat(_typeof(args), "\""));
      }

      this.actionBatcher.addAction(domain, action, args);
    }
    /**
     * (Async) Send a request to create a domain instance of the model specified
     * @async
     * @param {string} modelName - The name of the model from which to create the domain.
     * @param {Object} [args={}] - The arguments to pass to the domain creation.
     * @returns {string} The name of the created domain.
     * @throws Will throw an error if the client's authenticated token is invalid and
     *         `onAuthTokenFailure` has not been set.
     * @throws Will throw an error if provided parameters are invalid.
     * @throws Will throw an error if a domain with the same name as the created one already exists.
     */

  }, {
    key: "createDomain",
    value: function () {
      var _createDomain = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(modelName) {
        var _this6 = this;

        var args,
            _args9 = arguments;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                args = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : {};

                if (!(typeof modelName !== 'string')) {
                  _context9.next = 3;
                  break;
                }

                throw new Error("Parameter \"domain\" should be a string.Provided value is of type \"".concat(typeof domain === "undefined" ? "undefined" : _typeof(domain), "\""));

              case 3:
                if (!(_typeof(args) !== 'object')) {
                  _context9.next = 5;
                  break;
                }

                throw new Error("Parameter \"args\" should be an object.Provided value is of type \"".concat(_typeof(args), "\""));

              case 5:
                _context9.next = 7;
                return (0, _initializeConnection["default"])(this);

              case 7:
                if (!_context9.sent) {
                  _context9.next = 10;
                  break;
                }

                (0, _log["default"])("Creating domain instance of ".concat(modelName));
                return _context9.abrupt("return", new Promise(function (resolve, reject) {
                  _this6.actionSocket.emit('createDomain', {
                    modelName: modelName,
                    args: args
                  }, function (_ref9) {
                    var status = _ref9.status,
                        domainName = _ref9.domainName,
                        errMessage = _ref9.errMessage;

                    if (status === 'OK' && domainName) {
                      resolve(domainName);
                    } else {
                      reject(new Error(errMessage));
                    }
                  });
                }));

              case 10:
                return _context9.abrupt("return", null);

              case 11:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function createDomain(_x13) {
        return _createDomain.apply(this, arguments);
      }

      return createDomain;
    }()
    /**
     * (Async) Send a request to delete the specified domain.
     * @async
     * @param {string} domainName - The name of the domain to delete
     * @returns {boolean} Wether the request succeeded or not.
     * @throws Will throw an error if the client's authenticated token is invalid and
     *         `onAuthTokenFailure` has not been set.
     * @throws Will throw an error if provided parameters are invalid.
     * @throws Will throw an error if the domain does not exist.
     */

  }, {
    key: "deleteDomain",
    value: function () {
      var _deleteDomain = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(domainName) {
        var _this7 = this;

        var deleteDomainWithRetry;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(typeof domainName !== 'string')) {
                  _context10.next = 2;
                  break;
                }

                throw new Error("Parameter \"domain\" should be a string.Provided value is of type \"".concat(_typeof(domainName), "\""));

              case 2:
                _context10.next = 4;
                return (0, _initializeConnection["default"])(this);

              case 4:
                if (!_context10.sent) {
                  _context10.next = 8;
                  break;
                }

                (0, _log["default"])("Trying to delete domain \"".concat(domainName, "\""));

                deleteDomainWithRetry = function deleteDomainWithRetry(resolve, reject) {
                  var isRetry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                  _this7.actionSocket.emit('deleteDomain', {
                    domainName: domainName
                  }, function (_ref10) {
                    var status = _ref10.status,
                        payload = _ref10.payload,
                        errCode = _ref10.errCode,
                        errMessage = _ref10.errMessage;

                    if (status === 'OK' && payload) {
                      (0, _log["default"])("Successfully deleted domain \"".concat(domainName, "\""));
                      resolve(payload);
                    } else if (errCode === 'INVALID_DOMAIN' && !isRetry) {
                      setTimeout(function () {
                        deleteDomainWithRetry(resolve, reject, true);
                      }, 2000);
                    } else {
                      (0, _log["default"])("Failed to delete domain \"".concat(domainName, "\""));
                      reject(new Error(errMessage));
                    }
                  });
                };

                return _context10.abrupt("return", new Promise(deleteDomainWithRetry));

              case 8:
                return _context10.abrupt("return", false);

              case 9:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function deleteDomain(_x14) {
        return _deleteDomain.apply(this, arguments);
      }

      return deleteDomain;
    }()
    /**
     * (Async) Get the current state of a domain.
     * @async
     * @param {string} domain - The domain of which to get the current state.
     * @throws Will throw an error if the client's authenticated token is invalid and
     *         `onAuthTokenFailure` has not been set.
     * @throws Will throw an error if provided parameters are invalid.
     * @throws Will throw an error if the domain does not exist.
     */

  }, {
    key: "getCurrentState",
    value: function () {
      var _getCurrentState2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(domain) {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!(typeof domain !== 'string')) {
                  _context11.next = 2;
                  break;
                }

                throw new Error("Parameter \"domain\" should be a string.Provided value is of type \"".concat(_typeof(domain), "\""));

              case 2:
                _context11.next = 4;
                return (0, _initializeConnection["default"])(this);

              case 4:
                if (!_context11.sent) {
                  _context11.next = 6;
                  break;
                }

                return _context11.abrupt("return", (0, _getCurrentState3["default"])(this.subscriptionSocket, domain));

              case 6:
                return _context11.abrupt("return", null);

              case 7:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getCurrentState(_x15) {
        return _getCurrentState2.apply(this, arguments);
      }

      return getCurrentState;
    }()
    /**
     * (Async) Get the current server status.
     * @returns {string} Either "REACHABLE" or "UNREACHABLE".
     */

  }, {
    key: "getServerStatus",
    value: function () {
      var _getServerStatus2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var actionServerStatus, subscriptionServerStatus;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!this.url) {
                  _context12.next = 2;
                  break;
                }

                return _context12.abrupt("return", (0, _getServerStatus3["default"])(this.url));

              case 2:
                _context12.next = 4;
                return (0, _getServerStatus3["default"])(this.actionUrl);

              case 4:
                actionServerStatus = _context12.sent;
                _context12.next = 7;
                return (0, _getServerStatus3["default"])(this.subscriptionUrl);

              case 7:
                subscriptionServerStatus = _context12.sent;
                return _context12.abrupt("return", actionServerStatus && subscriptionServerStatus ? 'REACHABLE' : 'UNREACHABLE');

              case 9:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getServerStatus() {
        return _getServerStatus2.apply(this, arguments);
      }

      return getServerStatus;
    }()
    /**
     * (Async) Get the time offset between the client and server.
     * @param {AccuracyLevels} [accuracy=HIGH] - The accuracy of the time offset value to be returned.
     *                                           The higher the accuracy,
     *                                           the longer the time to get the response.
     * @returns {number} Time offset in milliseconds (server time - local time).
     * @throws Will throw if TimeSync failed to determine offset.
     * @throws Will throw an error if the client's authenticated token is invalid and
     *         `onAuthTokenFailure` has not been set.
     */

  }, {
    key: "getServerTimeOffset",
    value: function () {
      var _getServerTimeOffset = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var _this8 = this;

        var accuracy,
            _args14 = arguments;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                accuracy = _args14.length > 0 && _args14[0] !== undefined ? _args14[0] : _AccuracyLevels["default"].HIGH;

                if (Object.keys(_AccuracyLevels["default"]).includes(accuracy)) {
                  _context14.next = 3;
                  break;
                }

                throw new Error("Parameter \"accuracy\" should be a member of the \"AccuracyLevels\" enumeration. Provided value is \"".concat(accuracy, "\""));

              case 3:
                _context14.next = 5;
                return (0, _initializeConnection["default"])(this);

              case 5:
                if (!_context14.sent) {
                  _context14.next = 8;
                  break;
                }

                if (!this.timeSync) {
                  this.timeSync = new _TimeSync["default"](this.actionSocket, accuracy);
                }

                return _context14.abrupt("return", new Promise( /*#__PURE__*/function () {
                  var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(resolve, reject) {
                    var timeOffset;
                    return regeneratorRuntime.wrap(function _callee13$(_context13) {
                      while (1) {
                        switch (_context13.prev = _context13.next) {
                          case 0:
                            _context13.prev = 0;
                            _context13.next = 3;
                            return _this8.timeSync.requestTime();

                          case 3:
                            timeOffset = _context13.sent;
                            (0, _log["default"])("Requested server time, client offset is ".concat(timeOffset, "ms."));

                            if (Number.isFinite(Number(timeOffset))) {
                              resolve(timeOffset);
                            } else {
                              reject(new Error('Failed to determine time offset.'));
                            }

                            _context13.next = 11;
                            break;

                          case 8:
                            _context13.prev = 8;
                            _context13.t0 = _context13["catch"](0);
                            reject(_context13.t0);

                          case 11:
                          case "end":
                            return _context13.stop();
                        }
                      }
                    }, _callee13, null, [[0, 8]]);
                  }));

                  return function (_x16, _x17) {
                    return _ref11.apply(this, arguments);
                  };
                }()));

              case 8:
                return _context14.abrupt("return", null);

              case 9:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function getServerTimeOffset() {
        return _getServerTimeOffset.apply(this, arguments);
      }

      return getServerTimeOffset;
    }()
    /**
     * (Async) Add a subscription to a domain.
     * @param {string} domain - The name of the domain to subscribe to.
     * @param {function} listener - The function that will be called when
     *                              the domain's state is updated. It will
     *                              also be called with the current state right
     *                              after subscribing. Be aware that if the update
     *                              frequency is high, the listener will not be
     *                              notified of every intermediate state. But it
     *                              will always receive an up-to-date state eventually.
     * @throws Will throw an error if provided parameters are invalid.
     * @throws Will throw an error if the domain does not exist.
     * @throws Will throw an error if the client's authenticated token is invalid and
     *         `onAuthTokenFailure` has not been set.
     * @returns {Subscription} - The handle to the newly created subscription.
     */

  }, {
    key: "subscribe",
    value: function () {
      var _subscribe2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(domain, listener) {
        var _this9 = this;

        var subscription;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                if (!(typeof domain !== 'string')) {
                  _context16.next = 2;
                  break;
                }

                throw new Error("Parameter \"domain\" should be a string.Provided value is of type \"".concat(_typeof(domain), "\""));

              case 2:
                if (!(typeof listener !== 'function')) {
                  _context16.next = 4;
                  break;
                }

                throw new Error("Parameter \"listener\" should be a function.Provided value is of type \"".concat(_typeof(listener), "\""));

              case 4:
                _context16.next = 6;
                return (0, _initializeConnection["default"])(this);

              case 6:
                if (!_context16.sent) {
                  _context16.next = 11;
                  break;
                }

                subscription = new _Subscription["default"](listener, /*#__PURE__*/function () {
                  var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(theSubscription, initializationCallback) {
                    var onReconnect, _subscriptionCollection, subscriptionCollection;

                    return regeneratorRuntime.wrap(function _callee15$(_context15) {
                      while (1) {
                        switch (_context15.prev = _context15.next) {
                          case 0:
                            if (_this9.subscriptions[domain]) {
                              _context15.next = 6;
                              break;
                            }

                            _subscriptionCollection = {
                              domain: domain,
                              lastUpdateTimestamp: 0,
                              lastState: null,
                              lastStateJSON: null,
                              subscriptions: new Set([])
                            };
                            _context15.next = 4;
                            return (0, _subscribe3["default"])(_this9.subscriptionSocket, domain, function (newState) {
                              onStateUpdate(_subscriptionCollection, newState);
                            });

                          case 4:
                            onReconnect = _context15.sent;
                            _this9.subscriptions[domain] = _subscriptionCollection;

                          case 6:
                            subscriptionCollection = _this9.subscriptions[domain];

                            if (subscriptionCollection.lastState) {
                              listener(subscriptionCollection.lastState);
                            }

                            subscriptionCollection.subscriptions.add(theSubscription);
                            initializationCallback(function () {
                              // This function will be called on subscription.close()
                              subscriptionCollection.subscriptions["delete"](theSubscription);

                              _this9.subscriptionSocket.removeListener("".concat(domain, "/state"), listener);

                              _this9.subscriptionSocket.removeListener("".concat(domain, "/subscriptionError"));

                              _this9.subscriptionSocket.removeListener('connect', onReconnect);

                              if (subscriptionCollection.subscriptions.size === 0) {
                                _this9.subscriptionSocket.emit('unsubscribe', {
                                  domain: domain
                                });

                                delete _this9.subscriptions[domain];
                                (0, _log["default"])("Closed subscription to domain '".concat(domain, "'"));
                              }
                            });
                            (0, _log["default"])("Added subscription to domain '".concat(domain, "'"));

                          case 11:
                          case "end":
                            return _context15.stop();
                        }
                      }
                    }, _callee15);
                  }));

                  return function (_x20, _x21) {
                    return _ref12.apply(this, arguments);
                  };
                }());
                _context16.next = 10;
                return subscription.init();

              case 10:
                return _context16.abrupt("return", subscription);

              case 11:
                return _context16.abrupt("return", null);

              case 12:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function subscribe(_x18, _x19) {
        return _subscribe2.apply(this, arguments);
      }

      return subscribe;
    }()
    /**
     * Set an action to be executed on the server on this client’s disconnection.
     * @param {string} domain - The name of the domain on which to execute the action.
     * @param {string} action - The name of the action to execute on client's disconnection.
     * @param {object} [args = {}] - The action's arguments.
     * @throws Will throw an error if the client's authenticated token is invalid and
     *         `onAuthTokenFailure` has not been set.
     * @returns {boolean} - Wether the request succeeded or not.
     */

  }, {
    key: "executeOnDisconnect",
    value: function () {
      var _executeOnDisconnect = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(domain, action) {
        var _this10 = this;

        var args,
            _args17 = arguments;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                args = _args17.length > 2 && _args17[2] !== undefined ? _args17[2] : {};
                _context17.next = 3;
                return (0, _initializeConnection["default"])(this);

              case 3:
                if (!_context17.sent) {
                  _context17.next = 5;
                  break;
                }

                return _context17.abrupt("return", new Promise(function (resolve, reject) {
                  _this10.actionSocket.emit('setLastWill', domain, action, args, function (_ref13) {
                    var status = _ref13.status,
                        errMessage = _ref13.errMessage;

                    if (status === 'OK') {
                      resolve(true);
                    } else {
                      reject(new Error(errMessage));
                    }
                  });
                }));

              case 5:
                return _context17.abrupt("return", false);

              case 6:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function executeOnDisconnect(_x22, _x23) {
        return _executeOnDisconnect.apply(this, arguments);
      }

      return executeOnDisconnect;
    }()
    /**
    * Set the action to be executed on the server on this client’s disconnection to a no-op.
    * @returns {boolean} - Wether the request succeeded or not.
    * @throws Will throw an error if the client's authenticated token is invalid and
    *         `onAuthTokenFailure` has not been set.
    */

  }, {
    key: "clearExecuteOnDisconnect",
    value: function () {
      var _clearExecuteOnDisconnect = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var _this11 = this;

        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return (0, _initializeConnection["default"])(this);

              case 2:
                if (!_context18.sent) {
                  _context18.next = 4;
                  break;
                }

                return _context18.abrupt("return", new Promise(function (resolve) {
                  _this11.actionSocket.emit('cancelLastWill', function (_ref14) {
                    var status = _ref14.status;
                    if (status === 'OK') resolve(true);
                  });
                }));

              case 4:
                return _context18.abrupt("return", false);

              case 5:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function clearExecuteOnDisconnect() {
        return _clearExecuteOnDisconnect.apply(this, arguments);
      }

      return clearExecuteOnDisconnect;
    }()
  }]);

  return Client;
}();

var _default = Client;
exports["default"] = _default;